export const normalizeLevel = (level = "") =>
  level.trim().toUpperCase().replace(/[\s-]+/g, "_");
